import StudentRecords from "../../schoolpages/StudentForm";
//import TeacherRecords from "../../schoolpages/StudentList";

export const schContent = {
  "Student Records": StudentRecords,
//  "Teacher Records": TeacherRecords,
};
